/**
 * Utility functions for OAuth grant display in the Connected Applications section.
 */

// Re-export formatRelativeTime from the global functions folder
export { formatRelativeTime } from "../../../../functions/formatRelativeTime";

/**
 * Checks if a URL is a valid HTTP(S) URL.
 *
 * @param {string} url The URL to check.
 *
 * @returns {boolean} True if the URL is a valid HTTP(S) URL.
 */
export function isValidHttpUrl( url ) {
	if ( ! url ) {
		return false;
	}
	try {
		const parsed = new URL( url );
		return parsed.protocol === "http:" || parsed.protocol === "https:";
	} catch {
		return false;
	}
}

/**
 * Gets unique hostnames from an array of redirect URIs.
 *
 * @param {string[]} redirectUris The array of redirect URIs.
 *
 * @returns {string[]} Array of unique hostnames from valid HTTP(S) URLs.
 */
export function getRedirectHostnames( redirectUris ) {
	if ( ! redirectUris || ! Array.isArray( redirectUris ) ) {
		return [];
	}
	const hostnames = redirectUris
		.filter( isValidHttpUrl )
		.map( ( uri ) => new URL( uri ).hostname );
	return [ ...new Set( hostnames ) ];
}
